"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _antd = require("antd");
var _options = require("../options/options");
var _recognition = _interopRequireDefault(require("../../services/recognition"));
var _cmx = _interopRequireDefault(require("../../services/cmx"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const {
  Option
} = _antd.Select;
class RewardChoiceSelect extends _react.default.Component {
  state = {
    loading: false,
    rewardChoices: []
  };
  componentDidMount() {
    this.loadRewardChoices();
  }
  render() {
    const {
      hideAlreadySelected,
      ...props
    } = this.props;
    const {
      loading,
      rewardChoices
    } = this.state;
    let rewardChoiceOptions = rewardChoices;
    if (hideAlreadySelected) {
      rewardChoiceOptions = rewardChoiceOptions.filter(rc => !Array.isArray(props.value) || !props.value.includes(rc.id));
    }
    return /*#__PURE__*/_react.default.createElement(_antd.Select, _extends({
      loading: loading,
      showSearch: true,
      optionFilterProp: "children",
      filterOption: _options.filterOptions,
      tagRender: this.renderTag
    }, props), rewardChoiceOptions.map(rewardChoice => /*#__PURE__*/_react.default.createElement(Option, {
      key: rewardChoice.id,
      value: rewardChoice.id
    }, rewardChoice.name)));
  }
  renderTag = props => {
    const {
      value,
      closable,
      onClose
    } = props;
    let label = props.label;
    if (this.props.hideAlreadySelected) {
      const rewardChoice = this.state.rewardChoices.find(rc => rc.id === value);
      if (rewardChoice) {
        label = rewardChoice.name;
      }
    }
    return /*#__PURE__*/_react.default.createElement(_antd.Tag, {
      onMouseDown: event => {
        event.preventDefault();
        event.stopPropagation();
      },
      closable: closable,
      onClose: onClose,
      style: {
        marginRight: 3
      }
    }, label);
  };
  loadRewardChoices = async () => {
    const {
      auth
    } = this.props;
    this.setState({
      loading: true
    });
    try {
      const recognitionService = new _recognition.default(auth.state);
      const rewardChoices = await recognitionService.searchRewardChoices();
      const cmxService = new _cmx.default(auth.state);
      const strings = await cmxService.getStringsWithAttributes('recognition', 'en-US', [{
        name: 'rewardChoice.name',
        attributes: {
          rewardChoiceId: rewardChoices.map(rc => rc.id)
        }
      }]);
      const stringsMap = {};
      if (Array.isArray(strings['rewardChoice.name'])) {
        strings['rewardChoice.name'].forEach(s => {
          stringsMap[s.stringAttributes.rewardChoiceId] = s;
        });
      }
      let rewardChoiceOptions = [];
      rewardChoices.forEach(rc => {
        if (stringsMap[rc.id]) {
          rewardChoiceOptions.push({
            id: rc.id,
            name: stringsMap[rc.id].value
          });
        }
      });
      rewardChoiceOptions = rewardChoiceOptions.sort((a, b) => a.name.localeCompare(b.name, undefined, {
        'sensitivity': 'base'
      }));
      this.setState({
        rewardChoices: rewardChoiceOptions,
        loading: false
      });
    } catch (error) {
      console.error(error);
      this.setState({
        loading: false
      });
    }
  };
}
exports.default = RewardChoiceSelect;
//# sourceMappingURL=reward-choice-select.js.map